import styled from 'styled-components';
import { Link } from 'react-router-dom';
import UserAndActionsImport from '../user-and-actions/UserAndActions';

export const HeaderContainer = styled.div`
  border-bottom: 1px solid #e1e1e1;
  box-shadow: 0px -3px 10px 0 rgba(0, 0, 0, 0.2);
  margin-bottom: ${({ open }) => (open ? '-4.9rem' : '0')};
  background: #f7f7f7;
  z-index: 13;
  width: 100%;
  position: ${({ open }) => (open ? 'static' : 'fixed')};
`;

export const HeaderContent = styled.div`
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 200px 2fr 1fr;
  align-items: center;
  padding: 1rem 0;
  @media screen and (max-width: 800px) {
    grid-template-columns: auto 1fr auto;
    padding: 0.5rem 0;
  }
`;

export const Logo = styled(Link)`
  font-size: 3.2rem;
  color: #f9703e;
  font-weight: 900;
  padding-right: ${({ open }) => open && '2.5rem'};
  text-decoration: none;
  @media screen and (max-width: 800px) {
    margin: 0 auto;
    font-size: 2.4rem;
  }
`;

export const SearchIconContainer = styled.button`
  border: none;
  background: none;
  margin-top: 0.8rem;
  font-size: 2.5rem;
  outline: none;
  color: var(--d-grey);
  cursor: pointer;
  transition: all 0.2s;
  @media (hover: hover) {
    &:hover {
      color: var(--accent);
    }
  }
  @media screen and (min-width: 800px) {
    display: none;
  }
`;

export const UserAndActions = styled(UserAndActionsImport)`
  justify-self: end;
  @media screen and (max-width: 800px) {
    display: none;
  }
`;
